import { Injectable } from '@angular/core';

import { NotificationEntitiesType } from '@notifications/models/notification-entities-type';

@Injectable()
export class NotificationEntitiesService {
  entities: NotificationEntitiesType = {};

  registerEntities(entities: NotificationEntitiesType): void {
    this.entities = {
      ...this.entities,
      ...entities
    };
  }
}
